import * as Sentry from '@sentry/astro';
import {
  getSentryDsn,
  getSentryEnvironment,
  getSentryTracesSampleRate,
  sanitizeSentryBreadcrumb,
  sanitizeSentryEvent,
} from './src/services/sentry';

const dsn = getSentryDsn(import.meta.env.PUBLIC_SENTRY_DSN);

// Only initialize when a DSN is present so local/preview builds without
// PUBLIC_SENTRY_DSN still succeed and send nothing.
//
// After a production deploy, confirm in Sentry → Issues (environment=production)
// by visiting https://boilmyeggs.com. Optional one-off check: temporarily throw
// `new Error('Sentry production test')` in a client script, reload, then revert.
if (dsn) {
  const environment = getSentryEnvironment(
    import.meta.env.PUBLIC_SENTRY_ENVIRONMENT,
    import.meta.env.PROD,
  );

  Sentry.init({
    dsn,
    environment,
    sendDefaultPii: false,
    tracesSampleRate: getSentryTracesSampleRate(environment),
    integrations: [Sentry.browserTracingIntegration()],
    beforeBreadcrumb: sanitizeSentryBreadcrumb,
    beforeSend: sanitizeSentryEvent,
  });
}
